import { LogoSpinner } from '../Spinner';

const PageLoading = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <LogoSpinner size="48px" />
  </div>
);

export default PageLoading;
